import { axiosInstance } from '@/http-common';
import CustomStore from 'devextreme/data/custom_store';
import { userDetails } from '@/utils/tools';

function isNotEmpty(value: any) {
    return value !== undefined && value !== null && value !== '';
}

export async function getUser(email: string) {
    return axiosInstance.get(`/api/v1/user/${encodeURIComponent(email)}`);
}

export async function createUser(data: any) {
    try {
        await axiosInstance.post(
            `${process.env.VUE_APP_AUTHORIZATION_SERVICE_URL}/users/new`,
            { email: data.email }
        )
    } catch (err: any) {
        const detail = err.response?.data?.detail || ''
        if (detail.includes('already registered')) {
            throw new Error('modules.users.errors.email_registered')
        }
        throw new Error('modules.users.errors.auth_service')
    }

    try {
        return await axiosInstance.post('/api/v1/user', data)
    } catch (err: any) {
        throw new Error('modules.users.save_error')
    }
}

export async function updateUser(email: string, data: any) {
    try {
        await axiosInstance.patch(`/api/v1/user/${encodeURIComponent(email)}`, data)
    } catch (err: any) {
        throw new Error('modules.users.save_error')
    }
}

export async function deleteMany(emails: string[]) {
    try {
        await axiosInstance.patch(
            `${process.env.VUE_APP_AUTHORIZATION_SERVICE_URL}/users/deactivate`,
            { emails }
        )
    } catch (err: any) {
        const detail = err.response?.data?.detail || ''
        if (detail.includes('No users found')) {
            throw new Error('modules.users.errors.not_found')
        }
        throw new Error('modules.users.errors.auth_service')
    }

    try {
        await axiosInstance.delete('/api/v1/users', { params: { emails } })
    } catch (err: any) {
        throw new Error('modules.users.save_error')
    }
}

export function getStore() {
    return new CustomStore({
        cacheRawData: false,
        key: 'id',
        load(loadOptions) {
            return new Promise((resolve, reject) => {
                let params = '?';
                ['skip', 'take', 'sort', 'filter'].forEach(p => {
                    if (p in loadOptions && isNotEmpty(loadOptions[p])) {
                        params += `${p}=${JSON.stringify(loadOptions[p])}&`;
                    }
                });
                const currentUser = userDetails();
                if (currentUser?.company) {
                    params += `companyId=${encodeURIComponent(currentUser.company)}&`
                }
                params = params.slice(0, -1);
                params = params.endsWith('&') || params.endsWith('?')
                                    ? params.slice(0, -1)
                                        : params;
                axiosInstance
                    .get(`/api/v1/users${params}`)
                    .then(resp => {
                        const apiData = resp.data.data;
                        const items = apiData.result;
                        const count = apiData.count;

                        resolve({
                            data: items,
                            totalCount: count,
                        });
                    })
                    .catch(error => {
                        console.error('Users API load error:', error);
                        reject(error);
                    });
            });
        },
    });
}
